import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Menu, X, Moon, Sun } from "lucide-react";
import { useIsMobile } from "@/hooks/useIsMobile";
import { useTheme } from "@/context/ThemeContext";
import CurrencySelect from "@/components/CurrencySelect";

const ITEMS = [
  ["About", "/about", "nav-about"],
  ["Features", "/features", "nav-features"],
  ["Pricing", "/pricing", "nav-pricing"],
  ["Marketplace", "/marketplace", "nav-marketplace"],
  ["FAQs", "/faq", "nav-faqs"],
  ["Kenya", "/kenya", "nav-kenya"],
  ["Contact", "/contact", "nav-contact"],
  ["Sign In", "/login", "nav-signin"],
];

export default function PublicNav() {
  const nav = useNavigate();
  const isMobile = useIsMobile(768);
  const [open, setOpen] = useState(false);
  const { resolved, toggle } = useTheme();
  const dark = resolved === "dark";
  const go = (to) => { setOpen(false); nav(to); };

  const ThemeBtn = (
    <button className="k-btn k-btn-ghost" data-testid="public-theme-toggle" onClick={toggle}
      aria-label={dark ? "Switch to light theme" : "Switch to dark theme"}
      style={{ padding: "9px 11px", minHeight: 0 }}>
      {dark ? <Sun size={17} /> : <Moon size={17} />}
    </button>
  );

  const Logo = (
    <div data-testid="nav-logo" onClick={() => go("/")} style={{ cursor: "pointer" }} className="k-heading">
      <span style={{ fontWeight: 900, fontSize: 22, letterSpacing: "-.03em", display: "inline-block",
        borderBottom: "3px solid var(--accent-primary)", paddingBottom: 3 }}>Kadana</span>
    </div>
  );

  if (isMobile) {
    return (
      <header data-testid="public-nav" className="k-public-header" style={{ position: "relative", borderBottom: "1px solid var(--border)" }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "16px 18px" }}>
          {Logo}
          <div style={{ display: "flex", gap: 10, alignItems: "center" }}>
            {ThemeBtn}
            <button className="k-btn k-btn-primary" data-testid="nav-start-free" style={{ padding: "9px 16px", minHeight: 0 }} onClick={() => go("/register")}>Start free</button>
            <button className="k-btn k-btn-ghost" data-testid="mobile-nav-toggle" aria-label={open ? "Close menu" : "Open menu"}
              style={{ padding: "9px 11px", minHeight: 0 }} onClick={() => setOpen(o => !o)}>
              {open ? <X size={18} /> : <Menu size={18} />}
            </button>
          </div>
        </div>
        {open && (
          <nav data-testid="mobile-nav-menu" className="k-fadein" style={{ display: "flex", flexDirection: "column",
            padding: "6px 10px 14px", borderTop: "1px solid var(--border)", background: "var(--container)" }}>
            {ITEMS.map(([label, to, tid]) => (
              <a key={to} className="k-link" data-testid={tid} onClick={() => go(to)}
                style={{ cursor: "pointer", padding: "12px 10px", fontSize: 16, borderRadius: 8 }}>{label}</a>
            ))}
            <div style={{ padding: "12px 10px" }}><CurrencySelect compact /></div>
          </nav>
        )}
      </header>
    );
  }

  return (
    <header data-testid="public-nav" className="k-public-header" style={{ display: "flex", justifyContent: "space-between", alignItems: "center",
      padding: "22px 24px", borderBottom: "1px solid var(--border)", flexWrap: "wrap", gap: 12 }}>
      {Logo}
      <nav style={{ display: "flex", gap: 18, alignItems: "center", flexWrap: "wrap" }}>
        {ITEMS.map(([label, to, tid]) => (
          <a key={to} className="k-link" data-testid={tid} onClick={() => nav(to)} style={{ cursor: "pointer" }}>{label}</a>
        ))}
        <CurrencySelect compact />
        {ThemeBtn}
        <button className="k-btn k-btn-primary" data-testid="nav-start-free" onClick={() => nav("/register")}>Start free</button>
      </nav>
    </header>
  );
}
